import CompetitorsVerificationApp from "./CompetitorsVerificationApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";

export default vueAppWithPinia(CompetitorsVerificationApp);
